import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';
import { closeDialog } from '~/store/modules/dialog/actions';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestArqueacaoAutomatica({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'arqueacaoautomatica', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
    yield put(closeDialog());
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteArqueacaoAutomatica({ payload }) {
  try {
    const { idposto, idtanquefisico, params } = payload;

    yield call(api.put, `arqueacaotanque/cancela/${idposto}/${idtanquefisico}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { arqueacao, params } = payload;

    yield call(api.post, 'arqueacaoautomatica', arqueacao);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/arqueacaoautomatica');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idarqueacaoautomatica } = payload;

    const { data } = yield call(
      api.get,
      `arqueacaoautomatica/${idarqueacaoautomatica}`
    );
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { idarqueacaoautomatica, params } = payload;

    yield call(api.put, 'arqueacaoautomatica', idarqueacaoautomatica);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/arqueacaoautomatica');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'arqueacaoautomatica', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest(
    '@arqueacaoautomatica/ARQUEACAOAUTO_IN_REQUEST',
    requestArqueacaoAutomatica
  ),
  takeLatest(
    '@arqueacaoautomatica/DELETE_ARQUEACAOAUTO',
    deleteArqueacaoAutomatica
  ),
  takeLatest('@arqueacaoautomatica/SUCCESS_REMOVE', requestArqueacaoAutomatica),
  takeLatest('@arqueacaoautomatica/STORE_ARQUEACAOAUTO', store),
  takeLatest('@arqueacaoautomatica/FIND_ARQUEACAOAUTO', find),
  takeLatest('@arqueacaoautomatica/UPDATE_ARQUEACAOAUTO', update),
  takeLatest('@arqueacaoautomatica/RECORD_FILTERING', applyedFilters),
]);
